import React, { useEffect, useState } from "react";
import { Container_List1 } from "./Container_list1";
import { Container_List2 } from "./Container_list2";
import { Container_List3 } from "./Container_list3";
import { Container_List4 } from "./Container_list4";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";


export const EjemplosMenu1 = () => {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    request
      .get(`MenuUsuarios/AccesosMenus?idmodulo=5`)
      .then((result) => {
        const cards_array = result.map((item) => ({
          titulo: item.titulo,
          ruta: item.ruta,
        }));
        setCards(cards_array);
      })
      .catch((error) => {
        Swal.fire("MENUS COBRANZA", JSON.stringify(error), "error");
      });
  }, []);

  return (
    <Container_List4 titulo={"LISTADO DE REPORTES DE COBRANZA"} cards={cards} />
  );
};
